var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "p-0 m-0" },
    [
      _c(
        "b-col",
        { staticClass: "p-0 m-0" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-overlay",
                    {
                      attrs: {
                        show: _vm.consultando,
                        rounded: "sm",
                        "spinner-small": "",
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "p-5" },
                        [
                          _c(
                            "b-col",
                            [
                              !!_vm.firmaFormato1.urlDocumento
                                ? _c("ver-pdf-url", {
                                    attrs: {
                                      url: _vm.firmaFormato1.urlDocumento,
                                      texto: _vm.$t(
                                        "apeironGwApp.formalizacionFormato1Snp.mensajes.documentoFirmado",
                                        { fecha: _vm.firmaFormato1.fechaFirma }
                                      ),
                                      buttonVariant: "primary",
                                      tooltip: _vm.$t(
                                        "apeironGwApp.formalizacionFormato1Snp.acciones.visualizarDocumento"
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.firmaFormato1.urlDocumento &&
                              _vm.permitirFirmar
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.formalizacionFormato1Snp.acciones.previsualizarDocumento"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.formalizacionFormato1Snp.acciones.previsualizarDocumento')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        variant: "outline",
                                        disabled: _vm.consultando,
                                        block: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.previsualizarFormato()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "b-iconstack",
                                        { attrs: { "font-scale": "1" } },
                                        [
                                          !_vm.consultando
                                            ? _c("b-icon", {
                                                attrs: {
                                                  stacked: "",
                                                  icon: "file-earmark-medical",
                                                  variant: "primary",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.consultando
                                            ? _c("b-icon", {
                                                attrs: {
                                                  stacked: "",
                                                  icon: "file-earmark-arrow-down",
                                                  variant: "primary",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("b-icon", {
                                            attrs: {
                                              stacked: "",
                                              icon: "eye",
                                              variant: "success",
                                              "shift-v": "8",
                                              "shift-h": "6",
                                              scale: "0.6",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.formalizacionFormato1Snp.acciones.previsualizarDocumento"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.permitirFirmar
                        ? _c(
                            "b-row",
                            { staticClass: "p-5" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.formalizacionFormato1Snp.acciones.firmar"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.formalizacionFormato1Snp.acciones.firmar')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      attrs: {
                                        block: "",
                                        variant: "primary",
                                        disabled: _vm.consultando,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.verModalClave()
                                        },
                                      },
                                    },
                                    [
                                      !_vm.consultando
                                        ? _c("b-icon", {
                                            attrs: {
                                              icon: "person-check",
                                              variant: "primary",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.consultando
                                        ? _c("b-icon", {
                                            attrs: {
                                              icon: "file-earmark-arrow-down",
                                              variant: "primary",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.formalizacionFormato1Snp.acciones.firmarDocumento"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("visualizador-pdf", {
                    attrs: {
                      id: "visualizador-dictamen",
                      contenidoBase64: _vm.contenidoBase64,
                      mostrar: _vm.mostrarPdf,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      attrs: { name: "modal-firmar-uno", size: "md" },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-title",
                          fn: function () {
                            return [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.formalizacionFormato1Snp.mensajes.tituloModalFirmar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "modal-footer",
                          fn: function () {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    variant: "primary",
                                    disabled: !_vm.clave,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.firmarFormato()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.formalizacionFormato1Snp.acciones.firmar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.mostrarModalFirmarUno = false
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.formalizacionFormato1Snp.acciones.cerrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.mostrarModalFirmarUno,
                        callback: function ($$v) {
                          _vm.mostrarModalFirmarUno = $$v
                        },
                        expression: "mostrarModalFirmarUno",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.formalizacionFormato1Snp.mensajes.detalleModalFirmar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "apeironGwApp.formalizacionFormato1Snp.campos.password"
                                    ),
                                    "label-for": "input-clave",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: _vm.tipoCampoClave,
                                      name: "input-clave",
                                    },
                                    model: {
                                      value: _vm.clave,
                                      callback: function ($$v) {
                                        _vm.clave = $$v
                                      },
                                      expression: "clave",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-right" },
                            [
                              _c(
                                "b-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tipoCampoClave == "password",
                                      expression:
                                        "tipoCampoClave == 'password'",
                                    },
                                  ],
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      _vm.tipoCampoClave = "text"
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.formalizacionFormato1Snp.acciones.mostrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tipoCampoClave == "text",
                                      expression: "tipoCampoClave == 'text'",
                                    },
                                  ],
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      _vm.tipoCampoClave = "password"
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.formalizacionFormato1Snp.acciones.ocultar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }